module.exports = __webpack_public_path__ + "static/media/image_4.3ed53268.svg";